var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412.375,
    height: 149,
    viewBox: "0 0 412.375 149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11648",
    "data-name": "Rectangle 11648",
    width: 122,
    height: 149,
    transform: "translate(-9.799 553)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "products",
    transform: "translate(-180 -130)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57943",
    "data-name": "Group 57943",
    transform: "translate(232 114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57953",
    "data-name": "Group 57953",
    transform: "translate(-42.201 -537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57995",
    "data-name": "Group 57995",
    transform: "translate(187.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53683",
    "data-name": "Path 53683",
    d: "M10,0h99a10,10,0,0,1,0,20H10A10,10,0,0,1,10,0Z",
    transform: "translate(95.723 682)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11643",
    "data-name": "Rectangle 11643",
    width: 118.002,
    height: 87.045,
    rx: 5,
    transform: "translate(95.348 553.348)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_409",
    "data-name": "Line 409",
    x2: 98.733,
    transform: "translate(97.466 650.969)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_410",
    "data-name": "Line 410",
    x2: 55.758,
    transform: "translate(97.465 668.687)",
    fill: "none",
    stroke: "#bdc7cf",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_cart",
    transform: "translate(149.272 686.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M11.463,12.5H10.2L8.4,19.675a.449.449,0,0,1-.426.356H2.448a.442.442,0,0,1-.4-.292l-2.008-5.1a.536.536,0,0,1,.037-.461.428.428,0,0,1,.367-.219H6.546a.488.488,0,0,1,0,.972H1.114l1.63,4.129h4.9l1.8-7.174a.449.449,0,0,1,.426-.356h1.594a.488.488,0,0,1,0,.972Z",
    transform: "translate(0 -11.529)",
    fill: "#1a2d4c",
    stroke: "#1a2d4c",
    strokeWidth: 0.543
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M53.7,198.357a1.1,1.1,0,1,1,1.079-1.1A1.088,1.088,0,0,1,53.7,198.357Z",
    transform: "translate(-45.345 -186.454)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M184.663,198.311h-.079a1.117,1.117,0,1,1,.079,0Z",
    transform: "translate(-182.332 -186.407)",
    fill: "#1a2d4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58056",
    "data-name": "Group 58056",
    transform: "translate(48.104 551.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600",
    "data-name": "Path 53600",
    d: "M258.81,97.184,243.085,81.46a2.156,2.156,0,0,0-3.049,0L220,101.5h43.634Z",
    transform: "translate(-203.396 -79.744)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602",
    "data-name": "Path 53602",
    d: "M219.58,85.773,204.6,100.547a2.144,2.144,0,0,0,1.511.621h30.185l-13.47-15.395A2.157,2.157,0,0,0,219.58,85.773Z",
    transform: "translate(-204.598 -79.415)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833",
    "data-name": "Ellipse 833",
    cx: 3.377,
    cy: 3.498,
    rx: 3.377,
    ry: 3.498,
    transform: "translate(21.709 0)",
    fill: "#e7e9ed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58057",
    "data-name": "Group 58057",
    transform: "translate(42.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53683-2",
    "data-name": "Path 53683",
    d: "M10,0h99a10,10,0,0,1,0,20H10A10,10,0,0,1,10,0Z",
    transform: "translate(95.723 682)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11643-2",
    "data-name": "Rectangle 11643",
    width: 118.002,
    height: 87.045,
    rx: 5,
    transform: "translate(95.348 553.348)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_409-2",
    "data-name": "Line 409",
    x2: 98.733,
    transform: "translate(97.466 650.969)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_410-2",
    "data-name": "Line 410",
    x2: 55.758,
    transform: "translate(97.465 668.687)",
    fill: "none",
    stroke: "#bdc7cf",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_cart-2",
    "data-name": "ic_cart",
    transform: "translate(149.272 686.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1358-2",
    "data-name": "Path 1358",
    d: "M11.463,12.5H10.2L8.4,19.675a.449.449,0,0,1-.426.356H2.448a.442.442,0,0,1-.4-.292l-2.008-5.1a.536.536,0,0,1,.037-.461.428.428,0,0,1,.367-.219H6.546a.488.488,0,0,1,0,.972H1.114l1.63,4.129h4.9l1.8-7.174a.449.449,0,0,1,.426-.356h1.594a.488.488,0,0,1,0,.972Z",
    transform: "translate(0 -11.529)",
    fill: "#1a2d4c",
    stroke: "#1a2d4c",
    strokeWidth: 0.543
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359-2",
    "data-name": "Path 1359",
    d: "M53.7,198.357a1.1,1.1,0,1,1,1.079-1.1A1.088,1.088,0,0,1,53.7,198.357Z",
    transform: "translate(-45.345 -186.454)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360-2",
    "data-name": "Path 1360",
    d: "M184.663,198.311h-.079a1.117,1.117,0,1,1,.079,0Z",
    transform: "translate(-182.332 -186.407)",
    fill: "#1a2d4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58056-2",
    "data-name": "Group 58056",
    transform: "translate(48.104 551.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944-2",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600-2",
    "data-name": "Path 53600",
    d: "M258.81,97.184,243.085,81.46a2.156,2.156,0,0,0-3.049,0L220,101.5h43.634Z",
    transform: "translate(-203.396 -79.744)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602-2",
    "data-name": "Path 53602",
    d: "M219.58,85.773,204.6,100.547a2.144,2.144,0,0,0,1.511.621h30.185l-13.47-15.395A2.157,2.157,0,0,0,219.58,85.773Z",
    transform: "translate(-204.598 -79.415)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833-2",
    "data-name": "Ellipse 833",
    cx: 3.377,
    cy: 3.498,
    rx: 3.377,
    ry: 3.498,
    transform: "translate(21.709 0)",
    fill: "#e7e9ed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_327",
    "data-name": "Mask Group 327",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58034",
    "data-name": "Group 58034",
    transform: "translate(-102.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11645",
    "data-name": "Rectangle 11645",
    width: 119,
    height: 20,
    rx: 10,
    transform: "translate(95.723 682)",
    fill: "rgba(26,45,76,0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11643-3",
    "data-name": "Rectangle 11643",
    width: 118.002,
    height: 87.045,
    rx: 5,
    transform: "translate(95.348 553.348)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_409-3",
    "data-name": "Line 409",
    x2: 98.733,
    transform: "translate(97.466 650.969)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_410-3",
    "data-name": "Line 410",
    x2: 55.758,
    transform: "translate(97.465 668.687)",
    fill: "none",
    stroke: "#bdc7cf",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58023",
    "data-name": "Group 58023",
    transform: "translate(48.104 551.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944-3",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600-3",
    "data-name": "Path 53600",
    d: "M258.81,97.184,243.085,81.46a2.156,2.156,0,0,0-3.049,0L220,101.5h43.634Z",
    transform: "translate(-203.396 -79.744)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602-3",
    "data-name": "Path 53602",
    d: "M219.58,85.773,204.6,100.547a2.144,2.144,0,0,0,1.511.621h30.185l-13.47-15.395A2.157,2.157,0,0,0,219.58,85.773Z",
    transform: "translate(-204.598 -79.415)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833-3",
    "data-name": "Ellipse 833",
    cx: 3.377,
    cy: 3.498,
    rx: 3.377,
    ry: 3.498,
    transform: "translate(21.709 0)",
    fill: "#e7e9ed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ic_cart-3",
    "data-name": "ic_cart",
    transform: "translate(149.272 686.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1358-3",
    "data-name": "Path 1358",
    d: "M11.463,12.5H10.2L8.4,19.675a.449.449,0,0,1-.426.356H2.448a.442.442,0,0,1-.4-.292l-2.008-5.1a.536.536,0,0,1,.037-.461.428.428,0,0,1,.367-.219H6.546a.488.488,0,0,1,0,.972H1.114l1.63,4.129h4.9l1.8-7.174a.449.449,0,0,1,.426-.356h1.594a.488.488,0,0,1,0,.972Z",
    transform: "translate(0 -11.529)",
    fill: "#1a2d4c",
    stroke: "#1a2d4c",
    strokeWidth: 0.543
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359-3",
    "data-name": "Path 1359",
    d: "M53.7,198.357a1.1,1.1,0,1,1,1.079-1.1A1.088,1.088,0,0,1,53.7,198.357Z",
    transform: "translate(-45.345 -186.454)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360-3",
    "data-name": "Path 1360",
    d: "M184.663,198.311h-.079a1.117,1.117,0,1,1,.079,0Z",
    transform: "translate(-182.332 -186.407)",
    fill: "#1a2d4c"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProducts);
export default __webpack_public_path__ + "static/media/home-products.cc0d203771de8ab911a77bfc31d70ecf.svg";
export { ForwardRef as ReactComponent };